import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/thumbs-up-off.svg'
import _imports_1 from '@/assets/images/thumbs-up-on.svg'


const _withScopeId = n => (_pushScopeId("data-v-5368c967"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("一覧へ")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "text-right"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("解決済みにする")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("未解決にする")
const _hoisted_6 = { class: "info color-info" }
const _hoisted_7 = { class: "time" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "mt5" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("共感する")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("共感した")
const _hoisted_12 = { class: "text-right" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("編集")
const _hoisted_14 = { class: "comment-box mt20" }
const _hoisted_15 = { class: "mt10 mb10 text-right" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("送信")
const _hoisted_17 = { class: "info color-info" }
const _hoisted_18 = { class: "time" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "comment-iine" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-success" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "14",
    height: "14",
    class: "image-position"
  })
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-success" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    width: "14",
    height: "14",
    class: "image-position"
  })
], -1))
const _hoisted_23 = { class: "text-right" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("編集")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("削除")
const _hoisted_26 = { class: "mt5 text-right" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("保存 ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" キャンセル")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "削除しますか？")
], -1))
const _hoisted_30 = { class: "dialog-footer" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("キャンセル")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("削除")

import { onMounted, ref, computed } from 'vue'
import { ElMessage } from 'element-plus'
import { useStore } from "vuex";
import { useRoute } from 'vue-router'
import { PostLogic } from '@/logic/posts/PostLogic'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import BlotFormatter from 'quill-blot-formatter'
import ImageCompress from 'quill-image-compress'
import MagicUrl from 'quill-magic-url'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const toolbar = [
  ['bold', 'italic', 'underline'],
  [{ 'color': [] }, { 'background': [] }],
  ['link'],
  ['image'],
]
const modules = [{
  name: 'blotFormatter',
  module: BlotFormatter,
  options: {/* options */ }
},
{
  name: 'MagicUrl',
  module: MagicUrl,
  options: {/* options */ }
},
{
  name: 'ImageCompress',
  module: ImageCompress,
  options: {
    quality: 0.9,
    maxWidth: 1500,
    maxHeight: 1500,
    imageType: 'image/jpeg',
    debug: false,
    suppressErrorLogging: false, // default
  }
}
]
const quillOptions = {
  debug: 'error'
}
// コメント新規作成用のref
const commentNewEditor: any = ref(null)
// コメント編集用のref
const commentEditor = ref<{ [index: number]: any }>({})
const setQuillRef = (el: any) => {
  if (el == null) {
    return;
  }
  const target_id = el.$attrs.id
  if (target_id.match(/comment_([0-9]+)/)) {
    const comment_id = target_id.match(/comment_([0-9.]+)/)[1]
    commentEditor.value[comment_id] = el
  }
}

const { get, iine, cancelIine, comment, deleteComment, post, solve, updateComment, commentIine, commentCancelIine, postLoading } = PostLogic();
const route = useRoute();
const commentBody = ref('')
const store = useStore();
// const managerFlg = computed(() => store.state.login.manager_flg);
const managerFlg = computed(() => store.state.login.manager_flg || store.state.login.project_owner_flg);
let user_id = computed(() => store.state.login.user_id);
const deleteCommentConfirmDialogVisible = ref(false)
const delateCommentId = ref(0)

onMounted(async (): Promise<void> => {
  get(Number(route.params.post_id))
});

const checkSize = (new_body: string) => {
  if (!post.value) {
    return false
  }
  let length = post.value.body.length
  for (let i = 0; i < post.value.post_comments.length; i++) {
    length = length + post.value.post_comments[i].body.length
  }
  length = length + new_body.length
  let total_size = length / 1024 / 1024
  if (total_size > 5) {
    return false
  }
  return true
}

const sendComment = async () => {
  if (!post.value) {
    return
  }
  const body_html = commentNewEditor.value.getHTML()
  if (checkSize(body_html) == false) {
    ElMessage.error({
      message: '質問とコメント合わせて5MBまでになります',
      dangerouslyUseHTMLString: true,
      showClose: true,
      duration: 0
    });
  }
  await comment(post.value.id, body_html)
  commentBody.value = ''
  commentNewEditor.value.setText("")
}
const delateConfirmComment = (comment_id: number) => {
  delateCommentId.value = comment_id
  deleteCommentConfirmDialogVisible.value = true

  // @click="deleteComment(post.id, post_comment.id)"
}
const updateSaveComment = () => {
  if (!post.value) {
    editCommentId.value = 0
    return
  }
  const body_html = commentEditor.value[editCommentId.value].getHTML()
  if (checkSize(body_html) == false) {
    ElMessage.error({
      message: '質問とコメント合わせて5MBまでになります',
      dangerouslyUseHTMLString: true,
      showClose: true,
      duration: 0
    });
  }

  updateComment(post.value.id, editCommentId.value, body_html)
  editCommentId.value = 0
  editCommentBody.value = ""


}
const editCommentId = ref(0)
const editCommentBody = ref('')
const changeEditMode = (comment_id: number, body: string) => {
  editCommentId.value = comment_id
  editCommentBody.value = body
  commentEditor.value[editCommentId.value].setHTML(editCommentBody.value)


}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_router_link, {
        to: { name: 'Posts', params: { project_id: _ctx.$route.params.project_id } },
        class: "button-link"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, { type: "text" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"]),
      (_unref(post))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_unref(post).user_id == _unref(user_id) || _unref(managerFlg))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _withDirectives(_createVNode(_component_el_button, {
                    type: "success",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(solve)(_unref(post).id, true)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _unref(post).solved_flg == false]
                  ]),
                  _withDirectives(_createVNode(_component_el_button, {
                    type: "info",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(solve)(_unref(post).id, false)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _unref(post).solved_flg == true]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, [
                _createTextVNode(_toDisplayString(_unref(post).user_name) + " ", 1),
                _createElementVNode("span", _hoisted_7, "投稿日:" + _toDisplayString(_unref(post).post_at), 1)
              ]),
              _createElementVNode("div", {
                class: "body mt10 mb10",
                innerHTML: _unref(post).body
              }, null, 8, _hoisted_8),
              _createElementVNode("div", null, [
                _createVNode(_component_el_popover, {
                  placement: "top-start",
                  width: 200,
                  trigger: "hover",
                  disabled: _unref(post).iine_count == 0
                }, {
                  reference: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_unref(post).iine_count) + "人が共感しています", 1)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(post).iine_users, (user, i) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: i,
                        class: "iine-user"
                      }, _toDisplayString(user.user_name), 1))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                (_unref(post).iine == false)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(iine)(_unref(post).id)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(post).iine == true)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "info",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(cancelIine)(_unref(post).id))),
                      disabled: true
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_unref(post).user_id == _unref(user_id) || _unref(managerFlg))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: { name: 'PostEdit', params: { project_id: _ctx.$route.params.project_id, post_id: _unref(post).id } },
                    class: "button-link"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, { type: "text" }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_unref(QuillEditor), {
          ref: (_value, _refs) => {
            _refs['commentNewEditor'] = _value
            commentNewEditor.value = _value
          },
          theme: "snow",
          toolbar: toolbar,
          globalOptions: quillOptions,
          modules: modules,
          content: commentBody.value,
          "onUpdate:content": _cache[4] || (_cache[4] = ($event: any) => ((commentBody).value = $event)),
          contentType: 'html'
        }, null, 8, ["content"]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: sendComment,
            disabled: commentBody.value.replace(/<p>|<\/p>|<br>/g, '').length == 0
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(post)?.post_comments, (post_comment) => {
          return (_openBlock(), _createElementBlock("div", {
            key: post_comment.id,
            class: "mb10"
          }, [
            _createVNode(_component_el_card, { shadow: "none" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_17, [
                    _createTextVNode(_toDisplayString(post_comment.user_name) + " ", 1),
                    _createElementVNode("span", _hoisted_18, "投稿日:" + _toDisplayString(post_comment.post_at), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "body",
                    innerHTML: post_comment.body
                  }, null, 8, _hoisted_19),
                  _createElementVNode("div", _hoisted_20, [
                    _createTextVNode(_toDisplayString(post_comment.iine_count) + "人がいいねしてます ", 1),
                    (post_comment.iine == false)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "text",
                          onClick: ($event: any) => (_unref(commentIine)(_unref(post).id, post_comment.id))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_21
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (post_comment.iine == true)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "text",
                          onClick: ($event: any) => (_unref(commentCancelIine)(_unref(post).id, post_comment.id))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_22
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createVNode(_component_el_button, {
                      type: "text",
                      onClick: ($event: any) => (changeEditMode(post_comment.id, post_comment.body))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_24
                      ]),
                      _: 2
                    }, 1032, ["onClick"]), [
                      [_vShow, post_comment.user_id == _unref(user_id) || _unref(managerFlg)]
                    ]),
                    _withDirectives(_createVNode(_component_el_button, {
                      type: "text",
                      onClick: ($event: any) => (delateConfirmComment(post_comment.id))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_25
                      ]),
                      _: 2
                    }, 1032, ["onClick"]), [
                      [_vShow, post_comment.user_id == _unref(user_id) || _unref(managerFlg)]
                    ])
                  ])
                ], 512), [
                  [_vShow, editCommentId.value != post_comment.id]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(_unref(QuillEditor), {
                    id: 'comment_' + post_comment.id,
                    ref: setQuillRef,
                    theme: "snow",
                    toolbar: toolbar,
                    globalOptions: quillOptions,
                    modules: modules,
                    content: editCommentBody.value,
                    "onUpdate:content": _cache[5] || (_cache[5] = ($event: any) => ((editCommentBody).value = $event)),
                    contentType: 'html'
                  }, null, 8, ["id", "content"]),
                  _createElementVNode("div", _hoisted_26, [
                    _withDirectives(_createVNode(_component_el_button, {
                      type: "primary",
                      onClick: updateSaveComment,
                      disabled: editCommentBody.value.replace(/<p>|<\/p>|<br>/g, '').length == 0
                    }, {
                      default: _withCtx(() => [
                        _hoisted_27
                      ]),
                      _: 2
                    }, 1032, ["disabled"]), [
                      [_vShow, post_comment.user_id == _unref(user_id) || _unref(managerFlg)]
                    ]),
                    _withDirectives(_createVNode(_component_el_button, {
                      type: "text",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (editCommentId.value = 0))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_28
                      ]),
                      _: 2
                    }, 1536), [
                      [_vShow, post_comment.user_id == _unref(user_id) || _unref(managerFlg)]
                    ])
                  ])
                ], 512), [
                  [_vShow, editCommentId.value == post_comment.id]
                ])
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ]),
      _createVNode(_component_el_dialog, {
        title: "削除確認",
        modelValue: deleteCommentConfirmDialogVisible.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((deleteCommentConfirmDialogVisible).value = $event)),
        width: "30%",
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_30, [
            _createVNode(_component_el_button, {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (deleteCommentConfirmDialogVisible.value = false))
            }, {
              default: _withCtx(() => [
                _hoisted_31
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[8] || (_cache[8] = ($event: any) => {deleteCommentConfirmDialogVisible.value = false; _unref(deleteComment)(_unref(post).id, delateCommentId.value)})
            }, {
              default: _withCtx(() => [
                _hoisted_32
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _hoisted_29
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 512)), [
    [_directive_loading, _unref(postLoading)]
  ])
}
}

})